import { BalanceDocType } from "@src/types/business/balanceDocType";

/** Проверяет, что строка маршрута соответствует {@link BalanceDocType}. */
export function checkBalanceDocType(str: string): str is BalanceDocType {
    return str === BalanceDocType.Arrival || str === BalanceDocType.Leave;
}
